import React, { Component } from 'react'
import { connect } from 'react-redux'
import Axios from 'axios'
import { Link } from "react-router-dom"; //make sure to import all the components.
import "./QuoteReport.scss";
// Dialog dependencies
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import ReactLoader from 'react-loader-spinner'
import SettingsWrapper from "../../../../components/Settings/SettingsWrapper";

export class QuoteReport extends Component {
    state = {
        consultant_warehouse_table_rows: [],
        consultant_warehouses: [],
        is_everything_checked: 0, // We check this value to decide if we are checking all or un checking all
        use_advance_fields: false,
        dialog: null, // We use this for loading and to display messages from the API. If you don't want the dialog to show anymore just set it to null
    }

    componentDidMount = async () => {


        let get_consultant_warehouses_API_URL = this.props.API_URL + "/settings/reports"
        let data = {
            trend_ID: localStorage.getItem("trendId")
        }
        let get_consultant_warehouses_API_response = await Axios.post(get_consultant_warehouses_API_URL, data)


        let consultant_warehouse_table_rows = await get_consultant_warehouses_API_response.data.consultant_warehouses.map((consultant_warehouse, index) => {
            return (
                <tr>
                    <td>
                        <h3 class="application-settings-sub-header">{consultant_warehouse.warehouse}</h3>
                    </td>
                    <td class="settings-checkbox-td">
                        <input type="checkbox" class="dn" id={consultant_warehouse.warehouse} checked={consultant_warehouse.primary} onChange={() => this.toggle_primary_warehouse(index)} />
                        <label class="settings-label" htmlFor={consultant_warehouse.warehouse}>
                            <div class="settings-label-icon">&#10003;</div>
                        </label>
                    </td>
                </tr>
            )
        })
        this.setState({ consultant_warehouse_table_rows, consultant_warehouses: get_consultant_warehouses_API_response.data.consultant_warehouses }) // ES6 Object Destructuring Syntax
    }

    toggle_primary_warehouse = async (consultant_warehouse_index) => {
        let updated_consultant_warehouses = [...this.state.consultant_warehouses] // Making it immutable which means we aren't changing the original state. it's a good practice for some reason. I need to look into this to know exactly why or just ask Aman. If you are reading this Aman you were on vacation
        updated_consultant_warehouses[consultant_warehouse_index].primary = !updated_consultant_warehouses[consultant_warehouse_index].primary
        await this.setState({ consultant_warehouses: updated_consultant_warehouses })

        this.reRender_list_of_consultant_warehouse_table_rows()
    }

    reRender_list_of_consultant_warehouse_table_rows = async () => {
        let consultant_warehouse_table_rows = await this.state.consultant_warehouses.map((consultant_warehouse, index) => {
            return (
                <tr>
                    <td>
                        <h3 class="application-settings-sub-header">{consultant_warehouse.warehouse}</h3>
                    </td>
                    <td class="settings-checkbox-td">
                        <input type="checkbox" class="dn" id={consultant_warehouse.warehouse} checked={consultant_warehouse.primary} onChange={() => this.toggle_primary_warehouse(index)} />
                        <label class="settings-label" htmlFor={consultant_warehouse.warehouse}>
                            <div class="settings-label-icon">&#10003;</div>
                        </label>
                    </td>
                </tr>
            )
        })
        this.setState({ consultant_warehouse_table_rows }) // ES6 Object Destructuring Syntax
    }

    check_all = async () => {
        let is_everything_checked = this.state.is_everything_checked
        is_everything_checked = !is_everything_checked
        let updated_consultant_warehouses = [...this.state.consultant_warehouses] // Making it immutable which means we aren't changing the original state. it's a good practice for some reason. I need to look into this to know exactly why or just ask Aman. If you are reading this Aman you were on vacation
        updated_consultant_warehouses = await updated_consultant_warehouses.map(updated_consultant_warehouse => {
            updated_consultant_warehouse.primary = is_everything_checked
            return updated_consultant_warehouse
        })

        // It's true the most you use await the slower your application will run but using await in these cases shouldn't take long in the first place. it's just making sure its done performing the action before it moves on to the next step. So, it's fine in this scenario. 
        await this.setState({ consultant_warehouses: updated_consultant_warehouses, is_everything_checked })
        this.reRender_list_of_consultant_warehouse_table_rows()

    }

    generate_report = async () => {
        try {

            let dialog = <Dialog open={true} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title set-price-dialog-header">
                    Generating Report{" "}
                </DialogTitle>
                <DialogContent style={{ paddingRight: "10em" }}>
                    <ReactLoader
                        style={{ marginLeft: "8em" }}
                        type="Oval"
                        color="#00BFFF"
                        height={50}
                        width={50}
                    />
                </DialogContent>
            </Dialog>

            this.setState({ dialog })


            let generate_report_API_URL = this.props.API_URL + "/settings/reports/generate-report"

            // Find out which warehouses are set as primary to generate the report. 
            // This is not the place to change which warehouse is a primary warehouse
            let which_warehouses_are_checked = await this.state.consultant_warehouses.filter((consultant_warehouse) => {
                return consultant_warehouse.primary === true
            })

            let data = {
                warehouses: which_warehouses_are_checked,
                trendId: localStorage.getItem("trendId"),
                token: localStorage.getItem("token"),
                use_advance_fields: this.state.use_advance_fields,
                report_type: this.props.match.params.reportType
            }

            let generate_report_API_response = await Axios.post(generate_report_API_URL, data)

            dialog = <Dialog open={true} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title set-price-dialog-header">
                    Generating Report{" "}
                </DialogTitle>
                <DialogContent style={{ paddingRight: "10em" }}>
                    <React.Fragment><DialogContentText >
                        <p>{generate_report_API_response.data.API_response}</p>
                    </DialogContentText>
                        <Button style={{ marginLeft: "10em" }} id="set-price-close-button" onClick={() => this.setState({ dialog: null })} color="primary">
                            Okay
					</Button></React.Fragment>
                </DialogContent>
            </Dialog>

            this.setState({ dialog })



        } catch (error) {
            console.log("here is the error message when trying to generate the report ", error.message)
        }

    }

    // We use this to get the value of the URL parameter from the functional component that uses useParams(). That hook can only be used in a functional component. 
    save_quote_type_to_state = (quote_type) => {
        this.setState({ quote_type })
    }

    render() {
        let page_title = this.props.match.params.reportType;
        page_title = page_title.replace(/[^\w\s]/gi, " ");

        let main = (
            <>
                <div class="card user-profile-card">
                    <div class="card-body">
                        <h2 class="setting-header">Warehouse(s) used</h2>
                        <table class="table table-bordered search-results-table checkbox-table">
                            <tbody>
                                <tr>
                                    <td>
                                        <h3 class="application-settings-sub-header">All</h3>
                                    </td>
                                    <td class="settings-checkbox-td">
                                        <input type="checkbox" class="dn" id="select_all_consultant_warehouses" onChange={() => this.check_all()} />
                                        <label class="settings-label" htmlFor="select_all_consultant_warehouses">
                                            <div class="settings-label-icon">&#10003;</div>
                                        </label>
                                    </td>
                                </tr>
                                {this.state.consultant_warehouse_table_rows}
                            </tbody>
                        </table>
                        <div class="custom-checkbox-wrapper mb1">
                            <input type="checkbox" class="dn" id="use_advance_fields" onChange={() => {
                                this.setState({ use_advance_fields: !this.state.use_advance_fields })
                                console.log("advance value ", this.state.use_advance_fields)
                            }} />
                            <label class="custom-checkbox-label" htmlFor="use_advance_fields">
                                <div class="label-box"></div>
                                <div class="label-message">Use Advance Fields</div>
                            </label>
                        </div>
                        <div class="active-quote-buttons-container">
                            <button type="button" class="btn btn-primary pbook-settings-submit" onClick={this.generate_report}>
                                Generate Report
                            </button>

                            <Link to={{ pathname: "/settings/reports" }} exact>
                                <button type="button" class="btn btn-primary pbook-settings-submit" onClick={this.submit}>
                                    Back to Reports
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </>
        );

        return (
			<SettingsWrapper header={page_title} main={main} classes={"application-settings"} />
		);
    }
}

const mapStateToProps = (state) => ({
    API_URL: state.APIUrl,
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(QuoteReport)
